interface TableHeaderProps {
  columns: string[];
}

const TableHeadComponent: React.FC<TableHeaderProps> = ({ columns }) => {
  return (
    <thead>
      <tr className="bg-gray-100 text-gray-700">
        {columns.map((column, index) => (
          <th key={index} className="p-2 text-center">
            {column}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeadComponent;
